<template>
  <b-form-group
    :id="id"
    :class="hasSelectedAccounts ? 'mb-50' : 'mb-2'"
    :invalid-feedback="hasSelectedAccounts ? '' : errorMessage"
    :state="errorMessage === undefined ? null : false"
    :label="$tk(label) + ' *'"
  >
    <multiselect
      :options="accounts"
      :close-on-select="true"
      :preserve-search="true"
      :placeholder="$tk(placeholder)"
      label="title"
      :show-labls="false"
      select-label=""
      deselect-label=""
      :internal-search="false"
      :option-height="73"
      track-by="title"
      @focus.stop=""
      @search-change="(query) => searchAccounts(query)"
      @select="(selectedItem) => addAccounts(selectedItem)"
    >
      <template
        slot="option"
        slot-scope="props"
      >
        <div class="d-flex ">
          <div
            class="selected-item-thumbnail d-inline-block"
            :style="{ backgroundImage: 'url(' + props.option[imageLabel] + ')' }"
          />
          <div class="option__title d-inline-block align-self-center ml-2">
            {{ props.option[nameLabel] }}
          </div>
        </div>
      </template>
      <template
        slot="caret"
        slot-scope="{ toggle }"
      >
        <div
          class="multiselect__select"
          @mousedown.prevent.stop="toggle()"
        >
          <GjIcon
            class="icon-wrapper"
            name="ArrowDown_fill"
            size="21"
          />
        </div>
      </template>
    </multiselect>
  </b-form-group>
</template>
<script>
import Multiselect from 'vue-multiselect'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    Multiselect,
    GjIcon,
  },
  props: {
    accounts: {
      type: [Array, Object],
      required: true,
    },
    nameLabel: {
      type: String,
      default: 'name',
    },
    imageLabel: {
      type: String,
      default: 'imageUrl',
    },
    placeholder: {
      type: String,
      default: 'ClientPortal.Form.SearchAccount',
    },
    label: {
      type: String,
      default: 'ClientPortal.Form.ChooseAccounts',
    },
    errorMessage: {
      type: String,
      default: undefined,
    },
    id: {
      type: String,
      required: true,
    },
    hasSelectedAccounts: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, context) {
    const searchAccounts = query => {
      context.emit('search', query)
    }

    const addAccounts = item => {
      context.emit('add', item)
    }

    return { searchAccounts, addAccounts }
  },
}
</script>
<style lang="scss">
@import '@/assets/scss/libs/_vue-multiselect.scss';
</style>
